/**
 * Prefixes a path with the Vite app base (e.g. /ex4) for native anchors,
 * history.pushState, and new-tab links that bypass React Router's basename.
 */
function appBasePrefix(): string {
  const normalizedBase = (import.meta.env.BASE_URL || '/').replace(
    /^\/+|\/+$/g,
    ''
  );

  return normalizedBase ? `/${normalizedBase}` : '';
}

export function withAppBasePath(path: string): string {
  const prefix = appBasePrefix();

  return prefix ? `${prefix}${path}` : path;
}

/** Strips the Vite app base so the path can be passed to React Router navigate(). */
export function withoutAppBasePath(path: string): string {
  const prefix = appBasePrefix();

  if (!prefix) {
    return path;
  }

  if (path === prefix) {
    return '/';
  }

  return path.startsWith(`${prefix}/`) ? path.slice(prefix.length) : path;
}
